const FloatingShapes = (gsap, intensity) => {
	const random = (min, max) => {
		const delta = max - min;
		return (direction = 1) => (min + delta * Math.random()) * direction;
	};

	const rotate = (target, direction) => {
		gsap.to(target, randomTime2(), {
			rotation: randomAngle(direction),
			delay: randomDelay(),
			// ease: Sine.easeInOut,
			onComplete: rotate,
			onCompleteParams: [target, direction * -1],
		});
	};

	const moveX = (target, direction) => {
		gsap.to(target, randomTime(), {
			x: randomX(direction),
			// ease: Sine.easeInOut,
			onComplete: moveX,
			onCompleteParams: [target, direction * -1],
		});
	};

	const moveY = (target, direction) => {
		gsap.to(target, randomTime(), {
			y: randomY(direction),
			// ease: Sine.easeInOut,
			onComplete: moveY,
			onCompleteParams: [target, direction * -1],
		});
	};

	const randomX = random(1, 10);
	const randomY = random(1, 10);
	const randomDelay = random(0, 1);
	const randomTime = random(3, 5);
	const randomTime2 = random(5, 10);
	const randomAngle = random(-10, 10);

	// Grab the prefers reduced media query.
	const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

	const shapes = gsap.utils.toArray(".shape");

	// Check if the media query matches or is not available.
	if (mediaQuery.matches) {
		shapes.forEach((shape) => {
			gsap.set(shape, {
				x: 0,
				y: 0,
				rotation: 0,
			});

			moveX(shape, 0);
			moveY(shape, 0);
			rotate(shape, 0);
		});
	} else {
		shapes.forEach((shape) => {
			gsap.set(shape, {
				x: randomX(-1),
				y: randomX(1),
				rotation: randomAngle(-1),
			});

			moveX(shape, intensity);
			moveY(shape, -intensity);
			rotate(shape, intensity);
		});
	}

	// Ads an event listener to check for changes in the media query's value.
	mediaQuery.addEventListener("change", () => {
		if (mediaQuery.matches) {
			shapes.forEach((shape) => {
				gsap.set(shape, {
					x: 0,
					y: 0,
					rotation: 0,
				});

				moveX(shape, 0);
				moveY(shape, 0);
				rotate(shape, 0);
			});
		} else {
			shapes.forEach((shape) => {
				gsap.set(shape, {
					x: randomX(-1),
					y: randomX(1),
					rotation: randomAngle(-1),
				});

				moveX(shape, intensity);
				moveY(shape, -intensity);
				rotate(shape, intensity);
			});
		}
	});
};

export default FloatingShapes;
